export const productsMockData = [
	{
		name: "Apple Promo Bundle",
		sku: "Test_Promo_Bundle",
		badges: null,
		badges_label: null,
		manufacturer: null,
		stock_status: "OUT_OF_STOCK",
		categories: [
			{
				id: 53,
				name: "Wearable Tech",
				url_key: "wearable-tech",
				image:
					"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Wearable_tech.png",
			},
		],
		__typename: "BundleProduct",
		description: {
			html: "",
		},
		meta_title: "Test_Promo_Bundle",
		meta_description: "Test_Promo_Bundle ",
		price_range: {
			minimum_price: {
				regular_price: {
					value: 9998,
					currency: "ZAR",
				},
				final_price: {
					value: 7998,
					currency: "ZAR",
				},
				discount: {
					amount_off: 2000,
					percent_off: 20,
				},
			},
			maximum_price: {
				regular_price: {
					value: 9998,
					currency: "ZAR",
				},
				final_price: {
					value: 7998,
					currency: "ZAR",
				},
				discount: {
					amount_off: 2000,
					percent_off: 20,
				},
			},
		},
		price_tiers: [],
		image: {
			url:
				"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
			label: "Apple Promo Bundle",
		},
		small_image: {
			url:
				"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
			label: "Apple Promo Bundle",
		},
		media_gallery: [
			{
				url:
					"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
				label: "Apple Promo Bundle",
			},
		],
	},
	{
		name: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
		sku: "1280464751",
		badges: null,
		badges_label: null,
		manufacturer: null,
		stock_status: "OUT_OF_STOCK",
		categories: [
			{
				id: 49,
				name: "Phones & SIM",
				url_key: "phones",
				image:
					"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png",
			},
			{
				id: 50,
				name: "Smartphones",
				url_key: "smartphones",
				image: null,
			},
		],
		__typename: "BundleProduct",
		description: {
			html: "",
		},
		meta_title: "BundleTest4",
		meta_description: "BundleTest4 ",
		price_range: {
			minimum_price: {
				regular_price: {
					value: 20000,
					currency: "ZAR",
				},
				final_price: {
					value: 4000,
					currency: "ZAR",
				},
				discount: {
					amount_off: 16000,
					percent_off: 80,
				},
			},
			maximum_price: {
				regular_price: {
					value: 20000,
					currency: "ZAR",
				},
				final_price: {
					value: 4000,
					currency: "ZAR",
				},
				discount: {
					amount_off: 16000,
					percent_off: 80,
				},
			},
		},
		price_tiers: [],
		image: {
			url:
				"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
			label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
		},
		small_image: {
			url:
				"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
			label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
		},
		media_gallery: [
			{
				url:
					"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
				label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
			},
		],
	},
	{
		name: "Promo Bundle",
		sku: "Promo_Bundle",
		badges: null,
		badges_label: null,
		manufacturer: null,
		stock_status: "IN_STOCK",
		categories: [
			{
				id: 49,
				name: "Phones & SIM",
				url_key: "phones",
				image:
					"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png",
			},
		],
		__typename: "BundleProduct",
		description: {
			html: "",
		},
		meta_title: "Promo_Bundle",
		meta_description: "Promo_Bundle ",
		price_range: {
			minimum_price: {
				regular_price: {
					value: 5967,
					currency: "ZAR",
				},
				final_price: {
					value: 5967,
					currency: "ZAR",
				},
				discount: {
					amount_off: 0,
					percent_off: 0,
				},
			},
			maximum_price: {
				regular_price: {
					value: 5967,
					currency: "ZAR",
				},
				final_price: {
					value: 5967,
					currency: "ZAR",
				},
				discount: {
					amount_off: 0,
					percent_off: 0,
				},
			},
		},
		price_tiers: [],
		image: {
			url:
				"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
			label: "Promo Bundle",
		},
		small_image: {
			url:
				"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
			label: "Promo Bundle",
		},
		media_gallery: [
			{
				url:
					"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
				label: "Promo Bundle",
			},
		],
	},
	{
		name: "WearableTech Bundle",
		sku: "105577WBT_BN",
		badges: null,
		badges_label: null,
		manufacturer: null,
		stock_status: "OUT_OF_STOCK",
		categories: [
			{
				id: 52,
				name: "Accessories",
				url_key: "accessories",
				image:
					"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Accessories_1.png",
			},
			{
				id: 53,
				name: "Wearable Tech",
				url_key: "wearable-tech",
				image:
					"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Wearable_tech.png",
			},
		],
		__typename: "BundleProduct",
		description: {
			html: "",
		},
		meta_title: "Wearable_Tech_Bundle",
		meta_description: "Wearable_Tech_Bundle ",
		price_range: {
			minimum_price: {
				regular_price: {
					value: 24995,
					currency: "ZAR",
				},
				final_price: {
					value: 19995,
					currency: "ZAR",
				},
				discount: {
					amount_off: 5000,
					percent_off: 20,
				},
			},
			maximum_price: {
				regular_price: {
					value: 24995,
					currency: "ZAR",
				},
				final_price: {
					value: 19995,
					currency: "ZAR",
				},
				discount: {
					amount_off: 5000,
					percent_off: 20,
				},
			},
		},
		price_tiers: [],
		image: {
			url:
				"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
			label: "WearableTech Bundle",
		},
		small_image: {
			url:
				"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
			label: "WearableTech Bundle",
		},
		media_gallery: [
			{
				url:
					"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
				label: "WearableTech Bundle",
			},
		],
	},
];

export const searchTabsMockData = {
	Promotions: [
		{
			title:
				"Promotions 1 -Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title:
				"Promotions 2- Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title:
				"Promotions -3 Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title:
				"Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title:
				"Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title:
				"Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title:
				"Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title:
				"Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title:
				"Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title:
				"Promotions - last - Pre-Order the new Samsung Galaxy Note 20 and get a R4 000 Samsung accessory voucher.",
			description:
				"This is the power phone that forever changes how you work and play.",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
	],
	Specials: [
		{
			title: "Specials = Vodacom Double Deals | 2 For 1",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Specials 1= Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
	],
	Content: [
		{
			title: "Content - Vodacom Double Deals | 2 For 1",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Content - Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Content Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Content Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Content Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
	],
	Services: [
		{
			title: "Services - Vodacom Double Deals | 2 For 1",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Services-  Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Services Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Services Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
	],
	Help: [
		{
			title: "Help -Vodacom Double Deals | 2 For 1",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
		{
			title: "Red Hot Dealz",
			description:
				"Get Samsung Galaxy smartphones and capture moments with 8K Video Snap changes how you capture photos and video from 1399 PM X24 SAMSUNG GALAXY S20 ULTRA 128GB  SAMSUNG GALAXY TAB A 2019 10.1",
			button_txt: "Learn More",
			CTAButton_txt: "https://www.google.com/",
		},
	],
};

export const productSearchMock = {
	products: {
		total_count: 21,
		page_info: {
			page_size: 12,
			current_page: 1,
			total_pages: 2,
		},
		items: [
			{
				name: "Apple Promo Bundle",
				sku: "Test_Promo_Bundle",
				badges: null,
				badges_label: null,
				manufacturer: null,
				stock_status: "OUT_OF_STOCK",
				categories: [
					{
						id: 53,
						name: "Wearable Tech",
						url_key: "wearable-tech",
						image:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Wearable_tech.png",
					},
				],
				__typename: "BundleProduct",
				description: {
					html: "",
				},
				meta_title: "Test_Promo_Bundle",
				meta_description: "Test_Promo_Bundle ",
				price_range: {
					minimum_price: {
						regular_price: {
							value: 9998,
							currency: "ZAR",
						},
						final_price: {
							value: 7998,
							currency: "ZAR",
						},
						discount: {
							amount_off: 2000,
							percent_off: 20,
						},
					},
					maximum_price: {
						regular_price: {
							value: 9998,
							currency: "ZAR",
						},
						final_price: {
							value: 7998,
							currency: "ZAR",
						},
						discount: {
							amount_off: 2000,
							percent_off: 20,
						},
					},
				},
				price_tiers: [],
				image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
					label: "Apple Promo Bundle",
				},
				small_image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
					label: "Apple Promo Bundle",
				},
				media_gallery: [
					{
						url:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_smartwatch_bundle.png",
						label: "Apple Promo Bundle",
					},
				],
			},
			{
				name: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
				sku: "1280464751",
				badges: null,
				badges_label: null,
				manufacturer: null,
				stock_status: "OUT_OF_STOCK",
				categories: [
					{
						id: 49,
						name: "Phones & SIM",
						url_key: "phones",
						image:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png",
					},
					{
						id: 50,
						name: "Smartphones",
						url_key: "smartphones",
						image: null,
					},
				],
				__typename: "BundleProduct",
				description: {
					html: "",
				},
				meta_title: "BundleTest4",
				meta_description: "BundleTest4 ",
				price_range: {
					minimum_price: {
						regular_price: {
							value: 20000,
							currency: "ZAR",
						},
						final_price: {
							value: 4000,
							currency: "ZAR",
						},
						discount: {
							amount_off: 16000,
							percent_off: 80,
						},
					},
					maximum_price: {
						regular_price: {
							value: 20000,
							currency: "ZAR",
						},
						final_price: {
							value: 4000,
							currency: "ZAR",
						},
						discount: {
							amount_off: 16000,
							percent_off: 80,
						},
					},
				},
				price_tiers: [],
				image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
					label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
				},
				small_image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
					label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
				},
				media_gallery: [
					{
						url:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
						label: "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
					},
				],
			},
			{
				name: "20GB Data once off",
				sku: "DV2MY5697",
				badges: null,
				badges_label: null,
				manufacturer: null,
				stock_status: "OUT_OF_STOCK",
				categories: [
					{
						id: 49,
						name: "Phones & SIM",
						url_key: "phones",
						image:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png",
					},
					{
						id: 50,
						name: "Smartphones",
						url_key: "smartphones",
						image: null,
					},
				],
				__typename: "BundleProduct",
				description: {
					html: "20GB Data once off",
				},
				meta_title: "40GB Data Sim",
				meta_description: "42GB Data Sim",
				price_range: {
					minimum_price: {
						regular_price: {
							value: 199,
							currency: "ZAR",
						},
						final_price: {
							value: 199,
							currency: "ZAR",
						},
						discount: {
							amount_off: 0,
							percent_off: 0,
						},
					},
					maximum_price: {
						regular_price: {
							value: 199,
							currency: "ZAR",
						},
						final_price: {
							value: 199,
							currency: "ZAR",
						},
						discount: {
							amount_off: 0,
							percent_off: 0,
						},
					},
				},
				price_tiers: [],
				image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-web-largeid462978_2.jpg",
					label: "20GB Data once off",
				},
				small_image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-web-mediumid462978_2.jpg",
					label: "20GB Data once off",
				},
				media_gallery: [
					{
						url:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-web-largeid462978_2.jpg",
						label: "20GB Data once off",
					},
					{
						url:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-web-mediumid462978_2.jpg",
						label: "20GB Data once off",
					},
					{
						url:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/api-mobi-mediumid462978_2.jpg",
						label: "20GB Data once off",
					},
				],
			},
			{
				name: "Promo Bundle",
				sku: "Promo_Bundle",
				badges: null,
				badges_label: null,
				manufacturer: null,
				stock_status: "IN_STOCK",
				categories: [
					{
						id: 49,
						name: "Phones & SIM",
						url_key: "phones",
						image:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png",
					},
				],
				__typename: "BundleProduct",
				description: {
					html: "",
				},
				meta_title: "Promo_Bundle",
				meta_description: "Promo_Bundle ",
				price_range: {
					minimum_price: {
						regular_price: {
							value: 5967,
							currency: "ZAR",
						},
						final_price: {
							value: 5967,
							currency: "ZAR",
						},
						discount: {
							amount_off: 0,
							percent_off: 0,
						},
					},
					maximum_price: {
						regular_price: {
							value: 5967,
							currency: "ZAR",
						},
						final_price: {
							value: 5967,
							currency: "ZAR",
						},
						discount: {
							amount_off: 0,
							percent_off: 0,
						},
					},
				},
				price_tiers: [],
				image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
					label: "Promo Bundle",
				},
				small_image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
					label: "Promo Bundle",
				},
				media_gallery: [
					{
						url:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_bundle.jpg",
						label: "Promo Bundle",
					},
				],
			},
			{
				name: "WearableTech Bundle",
				sku: "105577WBT_BN",
				badges: null,
				badges_label: null,
				manufacturer: null,
				stock_status: "OUT_OF_STOCK",
				categories: [
					{
						id: 52,
						name: "Accessories",
						url_key: "accessories",
						image:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Accessories_1.png",
					},
					{
						id: 53,
						name: "Wearable Tech",
						url_key: "wearable-tech",
						image:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Wearable_tech.png",
					},
				],
				__typename: "BundleProduct",
				description: {
					html: "",
				},
				meta_title: "Wearable_Tech_Bundle",
				meta_description: "Wearable_Tech_Bundle ",
				price_range: {
					minimum_price: {
						regular_price: {
							value: 24995,
							currency: "ZAR",
						},
						final_price: {
							value: 19995,
							currency: "ZAR",
						},
						discount: {
							amount_off: 5000,
							percent_off: 20,
						},
					},
					maximum_price: {
						regular_price: {
							value: 24995,
							currency: "ZAR",
						},
						final_price: {
							value: 19995,
							currency: "ZAR",
						},
						discount: {
							amount_off: 5000,
							percent_off: 20,
						},
					},
				},
				price_tiers: [],
				image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
					label: "WearableTech Bundle",
				},
				small_image: {
					url:
						"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
					label: "WearableTech Bundle",
				},
				media_gallery: [
					{
						url:
							"https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/p/apple_huawei.png",
						label: "WearableTech Bundle",
					},
				],
			},
		],
		aggregations: [
			{
				count: 2,
				label: "Price",
				attribute_code: "price",
				options: [
					{
						count: 20,
						label: "*-100000",
						value: "*_100000",
					},
					{
						count: 1,
						label: "100000-*",
						value: "100000_*",
					},
				],
			},
			{
				count: 8,
				label: "Category",
				attribute_code: "category_id",
				options: [
					{
						count: 7,
						label: "Phones & SIM",
						value: "49",
					},
					{
						count: 5,
						label: "Smartphones",
						value: "50",
					},
					{
						count: 4,
						label: "Gaming",
						value: "69",
					},
					{
						count: 3,
						label: "Wearable Tech",
						value: "53",
					},
					{
						count: 3,
						label: "Tablets & Laptops",
						value: "59",
					},
					{
						count: 2,
						label: "Accessories",
						value: "52",
					},
					{
						count: 2,
						label: "Smart Home",
						value: "74",
					},
					{
						count: 1,
						label: "Gaming Laptops",
						value: "63",
					},
				],
			},
			{
				count: 2,
				label: "Manufacturer",
				attribute_code: "manufacturer",
				options: [
					{
						count: 14,
						label: "Apple",
						value: "5487",
					},
					{
						count: 1,
						label: "Samsung",
						value: "5488",
					},
				],
			},
			{
				count: 3,
				label: "Color",
				attribute_code: "color",
				options: [
					{
						count: 4,
						label: "Space Grey",
						value: "5486",
					},
					{
						count: 3,
						label: "Midnight Green",
						value: "5485",
					},
					{
						count: 2,
						label: "Black",
						value: "5442",
					},
				],
			},
			{
				count: 1,
				label: "Dynamic SKU",
				attribute_code: "sku_type",
				options: [
					{
						count: 21,
						label: "1",
						value: "1",
					},
				],
			},
			{
				count: 3,
				label: "bundle_product_price_bucket",
				attribute_code: "bundle_product_price_bucket",
				options: [
					{
						count: 2,
						label: "400_450",
						value: "400_450",
					},
					{
						count: 4,
						label: "2100_2150",
						value: "2100_2150",
					},
					{
						count: 4,
						label: "2300_*",
						value: "2300_*",
					},
				],
			},
			{
				count: 7,
				label: "Promotion Tag",
				attribute_code: "promotion_tag",
				options: [
					{
						count: 11,
						label: "Black Friday",
						value: "5512",
					},
					{
						count: 9,
						label: "Exclusive to Online",
						value: "5496",
					},
					{
						count: 4,
						label: "For Today Only",
						value: "5497",
					},
					{
						count: 3,
						label: "Red hot deal",
						value: "5509",
					},
					{
						count: 2,
						label: "Buy One Get One Free",
						value: "5533",
					},
					{
						count: 1,
						label: "2 is better than 1",
						value: "5508",
					},
					{
						count: 1,
						label: "Sim only deals",
						value: "5510",
					},
				],
			},
			{
				count: 4,
				label: "Payment Terms",
				attribute_code: "payment_terms",
				options: [
					{
						count: 7,
						label: "24 months",
						value: "5554",
					},
					{
						count: 7,
						label: "32 months",
						value: "5555",
					},
					{
						count: 6,
						label: "12 months",
						value: "5553",
					},
					{
						count: 1,
						label: "36 months",
						value: "5556",
					},
				],
			},
			{
				count: 3,
				label: "Package Type or Plan Name",
				attribute_code: "plan_name",
				options: [
					{
						count: 7,
						label: "myRed",
						value: "5542",
					},
					{
						count: 5,
						label: "myRed Data",
						value: "5543",
					},
					{
						count: 3,
						label: "Smart",
						value: "5545",
					},
				],
			},
			{
				count: 1,
				label: "Is Deal Locked",
				attribute_code: "is_deal_locked",
				options: [
					{
						count: 6,
						label: "1",
						value: "1",
					},
				],
			},
			{
				count: 1,
				label: "Is Deal Product",
				attribute_code: "is_deal_product",
				options: [
					{
						count: 21,
						label: "1",
						value: "1",
					},
				],
			},
			{
				count: 1,
				label: "Hide Product From Search And Listing Page",
				attribute_code: "is_hidden_product",
				options: [
					{
						count: 1,
						label: "1",
						value: "1",
					},
				],
			},
			{
				count: 5,
				label: "minutes_bucket",
				attribute_code: "minutes_bucket",
				options: [
					{
						count: 1,
						label: "100_150",
						value: "100_150",
					},
					{
						count: 1,
						label: "150_200",
						value: "150_200",
					},
					{
						count: 6,
						label: "200_250",
						value: "200_250",
					},
					{
						count: 6,
						label: "300_350",
						value: "300_350",
					},
					{
						count: 3,
						label: "350_*",
						value: "350_*",
					},
				],
			},
			{
				count: 4,
				label: "data_bucket",
				attribute_code: "data_bucket",
				options: [
					{
						count: 6,
						label: "*_50",
						value: "*_50",
					},
					{
						count: 6,
						label: "50_100",
						value: "50_100",
					},
					{
						count: 5,
						label: "100_150",
						value: "100_150",
					},
					{
						count: 1,
						label: "200_*",
						value: "200_*",
					},
				],
			},
			{
				count: 4,
				label: "airtime_bucket",
				attribute_code: "airtime_bucket",
				options: [
					{
						count: 9,
						label: "*_50",
						value: "*_50",
					},
					{
						count: 3,
						label: "50_100",
						value: "50_100",
					},
					{
						count: 3,
						label: "100_150",
						value: "100_150",
					},
					{
						count: 3,
						label: "200_*",
						value: "200_*",
					},
				],
			},
			{
				count: 10,
				label: "monthly_recurring_bucket",
				attribute_code: "monthly_recurring_bucket",
				options: [
					{
						count: 1,
						label: "100_150",
						value: "100_150",
					},
					{
						count: 2,
						label: "300_350",
						value: "300_350",
					},
					{
						count: 2,
						label: "350_400",
						value: "350_400",
					},
					{
						count: 3,
						label: "400_450",
						value: "400_450",
					},
					{
						count: 1,
						label: "500_550",
						value: "500_550",
					},
					{
						count: 2,
						label: "600_650",
						value: "600_650",
					},
					{
						count: 2,
						label: "700_750",
						value: "700_750",
					},
					{
						count: 1,
						label: "900_950",
						value: "900_950",
					},
					{
						count: 1,
						label: "1200_1250",
						value: "1200_1250",
					},
					{
						count: 2,
						label: "1300_*",
						value: "1300_*",
					},
				],
			},
			{
				count: 3,
				label: "Accessories",
				attribute_code: "accessories",
				options: [
					{
						count: 6,
						label: "Apple Airpods",
						value: "5547",
					},
					{
						count: 4,
						label: "Apple TV 4K 64GB",
						value: "5548",
					},
					{
						count: 3,
						label: "Samsung Galaxy Buds",
						value: "5550",
					},
				],
			},
			{
				count: 3,
				label: "Plan Type",
				attribute_code: "plan_type",
				options: [
					{
						count: 15,
						label: "Data & Voice",
						value: "5537",
					},
					{
						count: 5,
						label: "Data only",
						value: "5539",
					},
					{
						count: 3,
						label: "Airtime",
						value: "5538",
					},
				],
			},
			{
				count: 2,
				label: "Contract Type",
				attribute_code: "contract_type",
				options: [
					{
						count: 7,
						label: "Standard contract",
						value: "5540",
					},
					{
						count: 5,
						label: "Top up",
						value: "5541",
					},
				],
			},
		],
		sort_fields: {
			default: "product_ranking",
			options: [
				{
					label: "Position",
					value: "position",
				},
				{
					label: "Price",
					value: "price",
				},
				{
					label: "Deal Product Price",
					value: "bundle_product_price",
				},
				{
					label: "Is Deal Product",
					value: "is_deal_product",
				},
				{
					label: "Product Position",
					value: "product_ranking",
				},
			],
		},
	},
};
